import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import {
  selectScenario,
  saveScenarioData,
  toggleScenarioDialog,
} from '../../actions'
import { useState } from 'react'
import uuid from 'uuid'
import { checkNullorEmptyObj } from '../../../../lib/util'

const PREFIX = 'Scenario-dialog'
const classes = {
  main: `${PREFIX}`,
}

const PaperStyled = styled(Paper)({
  width: '50%',
  margin: '10% auto 0',
  padding: '0 20px',
  [`&.${classes.main} .MuiTypography-h6`]: {
    textAlign: 'center',
  },
  [`&.${classes.main} .MuiOutlinedInput-input`]: {
    padding: '10.5px 14px',
  },
  [`&.${classes.main} .MuiFormLabel-root`]: {
    color: 'color: gray !important;',
    fontSize: 14,
  },
})

export default function FormDialog() {
  const dispatch = useDispatch()
  const { remoteStorage, scenarioDialogOpen, selectedProjectId } = useSelector(
    state => state
  )

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState(null)

  const validationResults = () => {
    let result = {}
    if (!name) {
      result['name'] = {
        message: 'Please enter a name.',
      }
    }
    if (!description) {
      result['description'] = {
        message: 'Please enter a description.',
      }
    }
    return result
  }

  const validationMessage = (validationResults, field) => {
    return (
      !!validationResults &&
      validationResults[field] &&
      validationResults[field].message
    )
  }

  const handleNameChange = e => {
    setName(e.target.value)
    if (error && error['name'] && e.target.value) {
      setError({ ...error, name: null })
    }
  }

  const handleDescriptionChange = e => {
    setDescription(e.target.value)
    if (error && error['description'] && e.target.value) {
      setError({ ...error, description: null })
    }
  }

  const reset = () => {
    setName('')
    setDescription('')
  }

  const close = () => {
    dispatch(toggleScenarioDialog(false))
    reset()
  }

  const submit = e => {
    if (e) e.preventDefault()
    const scenario = {
      name,
      description,
      project_id: selectedProjectId,
    }

    if (!checkNullorEmptyObj(validationResults())) {
      setError(validationResults())
      return false
    }

    setError(null)

    if (remoteStorage.scenarios) {
      //todo: save new scenario to DB
    } else {
      scenario.id = uuid()
    }
    dispatch(saveScenarioData(scenario))
    dispatch(selectScenario(scenario.id))
    dispatch(toggleScenarioDialog(false))
    reset()
  }

  return (
    <Modal open={!!scenarioDialogOpen} onClose={close}>
      <PaperStyled className={classes.main}>
        <form onSubmit={submit}>
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">New Scenario</Typography>
              <TextField
                error={!!validationMessage(error, 'name')}
                autoFocus
                margin="dense"
                id="name"
                label="Name"
                variant="outlined"
                value={name}
                fullWidth
                onChange={handleNameChange}
                helperText={validationMessage(error, 'name')}
              />
              <TextField
                error={!!validationMessage(error, 'description')}
                margin="dense"
                id="description"
                label="Description"
                variant="outlined"
                value={description}
                fullWidth
                onChange={handleDescriptionChange}
                helperText={validationMessage(error, 'description')}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={2}
            direction="row"
            justifyContent="flex-end"
          >
            <Grid item>
              <Button type="button" onClick={close}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button type="submit">Ok</Button>
            </Grid>
          </Grid>
        </form>
      </PaperStyled>
    </Modal>
  )
}
